// Module
var code = `<tour-step-body><span translate="reviewer-tour_body"></span></tour-step-body>`;
// Exports
export default code;